import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * The short link a desk ad closes on (`/m/{event}/{partner}`): a post
 * carries no query strings, so the app forwards it to the attendee sign-up
 * with the sponsor to meet — the favorite intent it acts on after sign-up.
 */
const MeetRedirect: React.FC = () => {
  const { eventId = '', partnerId = '' } = useParams();
  const params = new URLSearchParams({
    action: 'favorite',
    partner_id: partnerId,
    event_id: eventId,
  });

  return <Navigate to={`/registration/attendee?${params.toString()}`} replace />;
};

export default MeetRedirect;
